// utility functions

// all action types used by the createAsyncThunk function
export enum LoadingStatus {
    fulfilled = "fulfilled",
    pending = "pending",
    rejected = "rejected",
    idle = "idle"
}